import Box from '@mui/material/Box';
import Masonry from '@mui/lab/Masonry';
import { Card, CardActionArea, CardMedia, Paper } from '@mui/material';
import { FullScreen, useFullScreenHandle } from "react-full-screen";
import { useState } from 'react';
import { allImages } from '../data/ImageLoader';

function MasonryGallery() {
  const handle = useFullScreenHandle();

  const [selectedIndex, setSelectedIndex] = useState<number | null>(null);

  const handleClick = (index: number) => {
    setSelectedIndex(index);
    handle.enter();
  };

  return (
    <Box sx={{ minHeight: 829 }}>
      <Masonry columns={{ sx: 2, md: 5 }} spacing={{ sx: 2, md: 4 }}>
        {allImages.map((image, index) => (
          <Card sx={{ maxWidth: 345 }} key={index + ""}>
            <CardActionArea onClick={() => handleClick(index)}>
              <CardMedia
                component="img"
                image={image}
                alt=""
                sx={{
                  display: 'block',
                  width: '100%',
                }}
              />
            </CardActionArea>
          </Card>    
        ))}
      </Masonry>
      <FullScreen handle={handle}>
        {handle.active && selectedIndex !== null && (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100vh', // full screen height
              bgcolor: 'background.default',
              p: 2,
              overflow: 'auto', // scroll if image is too big
            }}
          >
            <Paper elevation={4} sx={{ maxWidth: '90%', maxHeight: '90%' }}>
              <Card>
                <CardMedia
                  component="img"
                  image={allImages[selectedIndex]}
                  alt=""
                  sx={{
                    display: 'block',
                    width: '100%',
                    height: 'auto', // maintain aspect ratio
                    maxHeight: '90vh', // limit to screen height
                  }}
                />
              </Card>
            </Paper>
          </Box>
        )}
      </FullScreen>
    </Box>
  );
}

export default MasonryGallery;